import { API_URL } from '../helpers/axios';
import { ME_URL } from '@/services/auth-service';
import { isNil } from 'lodash';
import decode from 'jwt-decode';
import router from '../router';
import store from '@/store';
import axios from 'axios';
import LaravelErrors from '@/helpers/laravel-errors';
import * as jwtDecode from 'jwt-decode';

export const LOGIN_URL = '/login';
export const REFRESH_URL = '/oauth/token'
export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const CLIENT_ID = process.env.CLIENT_ID;
export const CLIENT_SECRET = process.env.CLIENT_SECRET;
export const ERROR_COULD_NOT_REFRESH_TOKEN = 'could_not_refresh_token';
export const IGNORED_ERROR_URLS = [
	API_URL + ME_URL
];

class AuthHelper {

	constructor() {
		this.refreshTokenPromise = null;
	}

	requireAuth(to, from, next) {
		if (!store.getters.isLoggedIn) {
			next({
				path: LOGIN_URL,
				query: {
					redirect: to.fullPath
				}
			});
		} else {
			store.dispatch('fetchMe');
			next();
		}
	}

	hasErrorStatus(response, status) {
		return (
			response.request &&
			response.request.status == status
		);
	}

	isIgnoredUrl(url) {
		return (IGNORED_ERROR_URLS.indexOf(url) == true);
	}

	isNotAuthenticatedResponse(response) {
		return (
			(this.hasErrorStatus(401) || this.hasErrorStatus(403)) &&
			! this.isIgnoredUrl(response.request.responseURL)
		);
	}

	addResponseInterceptor(authInstance) {
		// add interceptor for NotAuthenticated responses
		authInstance.interceptors.response.use(undefined, (error) => {

			if (error.response && this.isNotAuthenticatedResponse(error.response)) {
				this.logout();
			}

			return Promise.reject(error);
		});
	}

	addRequestInterceptor(authInstance) {
		authInstance.interceptors.request.use(
			(config) => this.getValidAccessToken().then(
				(accessToken) => {
					config.headers['Authorization'] = 'Bearer ' + accessToken;
					return config;
				}
			)
		);
	}

	logout() {
		// send the user back to the login screen
		store.dispatch('logout');
		router.push({ name: 'Login' });
	}

 	refreshToken() {
		if(!isNil(this.refreshTokenPromise)) {
			return this.refreshTokenPromise;
		}

		this.refreshTokenPromise = axios({
			method: 'post',
			url: API_URL + REFRESH_URL,
			data: {
				client_id: CLIENT_ID,
				client_secret: CLIENT_SECRET,
				grant_type: 'refresh_token',
				refresh_token: this.getRefreshToken(),
			}
		})
		.then(response => {

			this.setAccessToken(response.data[ACCESS_TOKEN]);
			this.setRefreshToken(response.data[REFRESH_TOKEN]);

			return this.getAccessToken();

		})
		.catch(error => {

			if(error.response.data.error == ERROR_COULD_NOT_REFRESH_TOKEN) {
				this.logout();
			}

			throw error;

		});

		return this.refreshTokenPromise;

	}

	getTokenExpirationDate(encodedToken) {
		const token = jwtDecode(encodedToken);

		if(!token.exp) return null;

		const date = new Date(0);
	 	date.setUTCSeconds(token.exp);

		return date;
	}

	isTokenExpired(token) {
		const expirationDate = this.getTokenExpirationDate(token);
		const currentDate = new Date();

		return (expirationDate < currentDate);
	}

	getValidAccessToken() {
		let accessToken = this.getAccessToken();

		if( ! this.isTokenExpired(accessToken) ) {
			return Promise.resolve(accessToken);
		} else {
			return this.refreshToken()
				.then(accessToken => {
					this.refreshTokenPromise = null
					return accessToken;
				});
		}
	}

	getAccessToken() {
		return localStorage.getItem(ACCESS_TOKEN);
	}

	setAccessToken(accessToken) {
		localStorage.setItem(ACCESS_TOKEN, accessToken);
	}

	getRefreshToken() {
		return localStorage.getItem(REFRESH_TOKEN);
	}

	setRefreshToken(refreshToken) {
		localStorage.setItem(REFRESH_TOKEN, refreshToken);
	}

	removeAccessToken() {
		localStorage.removeItem(ACCESS_TOKEN);
	}
}

export default new AuthHelper()



// WEBPACK FOOTER //
// ./src/helpers/auth.js